import { Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import Slider from "../components/Slidbar/Slidbar";
import { ProfileSeeker } from "../components/ProfileSeeker/ProfileSeeker";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Seeker } from "../app/slices/Users/seekerSlice";

export const ProfileSeekerView = () => {
  const { id } = useParams(); // Extract seeker ID from URL parameters
  const dispatch = useDispatch();
  
  const {
    seekerProfile: { profile, loading },
  } = useSelector((state) => state.seeker);

  // Load seeker data when component mounts or ID changes
  useEffect(() => {
    if (id) {
      dispatch(Seeker.showById(id));
    }
  }, [id, dispatch]);

  // Show loading spinner while data is being fetched
  if (loading) {
    return (
      <>
        <Slider />
        <Box sx={{ ml: -1, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <CircularProgress size={60} />
        </Box>
      </>
    );
  }

  return (
    <>
      <Slider />
      <Box sx={{ ml: -1 }}>
        <ProfileSeeker data={profile} />
      </Box>
    </>
  );
};
